import React, { Component } from "react";
import * as R from "ramda";
import { getConfigSales } from "./config";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class SalesReportBy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableConfig: [],
            dataTable: [],
        };
    };

    componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: getConfigSales(this.props.tab),
        }));
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch === true) {
            this.fetchData(this.props.search);
            this.props.changeDoSearch(false);
        }
    }

    fetchData = async (payload) => {
        let res = {};
        this.props.triggerLoading();
        if (this.props.tab === "variant") {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerVariantKacab,
                menuName: "Dashboard Kacab - Laporan Jualan Per Type - Laporan Jualan Per varian",
                setError: this.props.setError,
                args: payload,
            });
        } else if (this.props.tab === "type") {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerTypeKacab,
                menuName: "Dashboard Kacab - Laporan Jualan Per Type - Laporan Jualan Per Tipe",
                setError: this.props.setError,
                args: payload,
            });
        } else if (this.props.tab === "series") {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerSeriesKacab,
                menuName: "Dashboard Kacab - Laporan Jualan Per Type - Laporan Jualan Per Series",
                setError: this.props.setError,
                args: payload,
            });
        } else if (this.props.tab === "subSegment") {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerSubSegmentKacab,
                menuName: "Dashboard Kacab - Laporan Jualan Per Type - Laporan Jualan Per Sub Segment",
                setError: this.props.setError,
                args: payload,
            });
        }

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data
            }));
        }
        this.props.triggerLoading();
    };


    render() {
        return (
            <>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    // toCount={0}
                    // rowsPerPage={10}
                    // page={0}
                    options={{pagination: false, serverSide: false}}
                />
            </>
        );
    };
}

export default SalesReportBy;